import React from "react";
import { ContentRowInformation, Pipeline } from "../../types/statusTypes";
import Row from "./StatusRow";

interface TableProps {
  contentStatuses: ContentRowInformation[];
}

export default function StatusTable({ contentStatuses }: TableProps) {
  const columns = [
    "Content ID",
    ...Object.values(Pipeline),
  ];

  return (
    <table className="status-table table">
      <thead>
        <tr>
          {columns.map((col, index) => (
            <th key={index}>{col}</th>
          ))}
        </tr>
      </thead>
      <tbody>
        {contentStatuses.map((item, index) => (
          <Row key={index} rowData={item} />
        ))}
      </tbody>
    </table>
  );
}
